// @flow

import { graphql } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

type MutationOptions = {
  variables: {
    input: {
      itemId: string,
    },
  },
};

const mutation = graphql`
  mutation AddItemQtyMutation($input: AddItemQtyInput!) {
    addItemQty(input: $input) {
      itemEdge {
        node {
          id
          totalQty
          totalValue
          logs {
            id
            user {
              id
            }
            lot {
              id
            }
            fromLot {
              id
            }
            operation
            quantity
            notes
            createdAt
          }
          lots(first: null) {
            edges {
              ...ItemLots_itemLotEdges
            }
          }
        }
      }
    }
  }
`;

export default {
  commit: (options: MutationOptions) => {
    const { itemId } = options.variables.input;

    return createRelayMutation(mutation, {
      ...options,
      updater: store => {
        // Traverse the mutation response until we find the updated item edge
        const updatedLots = store
          .getRootField('addItemQty')
          .getLinkedRecord('itemEdge')
          .getLinkedRecord('node')
          .getLinkedRecord('lots')
          .getLinkedRecords('edges');

        // Retrieve the root query
        const root = store.getRoot().getLinkedRecord('item', {
          id: itemId,
        });

        // Retrieve the root query's items array
        const conn = ConnectionHandler.getConnection(root, 'Item_lots');

        conn.setLinkedRecords(updatedLots, 'edges');
      },
    });
  },
};
